import { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'

import { theme } from '@plurall/elo-beta'

import { getToken } from 'utils'

const apiUrl = process.env.REACT_APP_PLURALL_MENU_API_URL
  ? `${process.env.REACT_APP_PLURALL_MENU_API_URL}/plurall`
  : `${process.env.REACT_APP_PLURALL_API_URL}/menus/menu-web-app`

interface IMenuItemsType {
  id: number
  name: string
  slug: string
  target: string
  weight: number
  category: {
    id: number | null
    name: string | null
    slug: string | null
  }
  icon_url: string | null
  link_url: string
  icon_class: string | null
  description: string
  card_visible: number
}
interface IMenuItems extends IMenuItemsType {
  sub_items?: IMenuItemsType[]
}
interface IMenuData {
  menu: {
    items: IMenuItems[]
  }
  userId: number
}
const useMainMenu = () => {
  const [isFetching, setIsFetching] = useState(true)
  const [getMenuData, setMenuData] = useState<IMenuItems[]>([])

  const currentPath = window.location?.href ? new URL(window.location.href).pathname : ''

  const isCurrentPath = (url: string) => {
    const currentItemPath = new URL(url)?.pathname
    if (currentItemPath === '/perfil') {
      return false
    }
    return currentPath.includes(currentItemPath)
  }
  // eslint-disable-next-line no-return-assign
  const onClick = (url: string) => (window.location.href = url)

  const isTabletBreakpoint = useMediaQuery({
    query: theme.elo.breakpoints.tablet,
  })
  const isDesktopBreakpoint = useMediaQuery({
    query: theme.elo.breakpoints.desktop,
  })

  useEffect(() => {
    if (isFetching) {
      const fetchMenuData = async () => {
        try {
          const response = await fetch(`${apiUrl}`, {
            method: 'GET',
            headers: {
              Accept: 'vnd.plurall.api.v2+json',
              'Content-Type': 'application/json',
              client: 'header-component-account',
              Authorization: `Bearer ${getToken()}`,
            },
          })
          const data: IMenuData = await response.json()
          const account = data.menu?.items?.find(({ slug }) => slug === 'account')?.sub_items || []

          setMenuData(account)
        } catch (error) {
          console.warn(error)
        } finally {
          setIsFetching(false)
        }
      }

      fetchMenuData()
    }
  }, [isFetching])

  return {
    isFetching,
    getMenuData,
    isCurrentPath,
    onClick,
    isTabletBreakpoint,
    isDesktopBreakpoint,
  }
}

export default useMainMenu
